/**
 * Records that can occupy a visible slot in Queue All.
 *
 * Keep this predicate shared by the server-page selector and the Queue UI. If
 * pagination counts records that the UI later removes, a nominal 30-record
 * page can collapse to only a handful of cards.
 */
export const isVisibleQueueHistoryEvent = (event = {}) => {
  const record = event.originalData || event;

  return !event.type?.startsWith('adjudication_') &&
    record.source !== 'adjudication' &&
    !event.voided &&
    !record.voided &&
    event.adjudicationStatus !== 'voided';
};
